document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-pack-purchase-form]').forEach(function (form) {
    form.addEventListener('submit', async function (e) {
      e.preventDefault();

      const variantId = form.dataset.variantId;
      if (!variantId) return;

      const button = form.querySelector('button[type="submit"]');
      if (button) button.disabled = true;

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: 1 }] }),
        });

        if (!response.ok) {
          const errorText = await response.text();
          let error;
          try {
            error = JSON.parse(errorText);
          } catch (_e) {
            error = { description: errorText };
          }
          throw new Error(error.description || error.message || 'Failed to add to cart');
        }

        // Fetch updated cart
        const cartResponse = await fetch('/cart.js');
        const cart = await cartResponse.json();
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));

        // Refresh cart drawer via section rendering
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer) {
          const sectionsToRender = ['cart-drawer', 'cart-icon-bubble'];
          const sectionsResponse = await fetch(
            `${window.Shopify.routes.root}?sections=${sectionsToRender.join(',')}`
          );

          if (sectionsResponse.ok) {
            const sectionsData = await sectionsResponse.json();
            const parsedState = { sections: sectionsData };

            cartDrawer.classList.remove('is-empty');

            if (typeof cartDrawer.renderContents === 'function') {
              cartDrawer.renderContents(parsedState);
            } else {
              const cartDrawerItems = document.querySelector('cart-drawer-items');
              const cartDrawerFooter = document.querySelector('.cart-drawer__footer');

              if (cartDrawerItems && sectionsData['cart-drawer']) {
                const parser = new DOMParser();
                const doc = parser.parseFromString(sectionsData['cart-drawer'], 'text/html');
                const newItems = doc.querySelector('cart-drawer-items');
                const newFooter = doc.querySelector('.cart-drawer__footer');
                if (newItems) cartDrawerItems.replaceWith(newItems);
                if (newFooter && cartDrawerFooter) cartDrawerFooter.replaceWith(newFooter);
              }

              if (typeof cartDrawer.open === 'function') {
                cartDrawer.open();
              } else {
                cartDrawer.classList.add('animate', 'active');
              }
            }

            // Update cart icon bubble
            if (sectionsData['cart-icon-bubble']) {
              const cartIconBubble = document.getElementById('cart-icon-bubble');
              if (cartIconBubble) {
                const parser = new DOMParser();
                const doc = parser.parseFromString(sectionsData['cart-icon-bubble'], 'text/html');
                const newCartIcon = doc.querySelector('.shopify-section');
                if (newCartIcon) cartIconBubble.innerHTML = newCartIcon.innerHTML;
              }
            }
          }
        }
      } catch (error) {
        console.error('Pack purchase add to cart error:', error);
      } finally {
        if (button) button.disabled = false;
      }
    });
  });
});
